import { type FC } from 'react';

import { AvailabilityBadge } from '../../AvailabilityBadge';
import { Box } from '../../Box';
import { Text } from '../../Typography';
import { UserCard } from '../../UserCard';

export type ReviewReplyProps = {
  avatarSrc?: string;
  name: string;
  date: string;
  content: string;
  label?: string;
  rating: number;
};

const ReviewReply: FC<ReviewReplyProps> = ({
  avatarSrc,
  name,
  date,
  content,
  label,
  rating,
}) => {
  return (
    <Box
      backgroundColor="var(--surface-neutral)"
      borderRadius="var(--spacing-3)"
      p="var(--spacing-4)"
      display="flex"
      flexDirection="column"
      gap="var(--spacing-3)"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap="var(--spacing-2)"
      >
        <UserCard
          avatarSrc={avatarSrc}
          title={name}
          subtitle={date}
          rating={rating}
        />

        <AvailabilityBadge variant="neutral">{label}</AvailabilityBadge>
      </Box>

      <Text>{content}</Text>
    </Box>
  );
};

export default ReviewReply;
